














































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { Invoice, Revenue, RevenueStatus } from '@/services/models'

import CustomerSelector from '@/components/CustomerSelector.vue'
import DatePicker from '@/components/DatePicker.vue'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    DatePicker,
    CustomerSelector,
  },
})
export default class EditInvoiceModal extends Vue {

  @Getter('firestore/revenues')
  private revenues!: Revenue[]

  @Action('firestore/fetchRevenues')
  private fetchRevenues!: () => Promise<void>

  @Action('firestore/writeInvoice')
  private writeInvoice!: (invoice: Invoice) => Promise<void>

  private selectedRevenue: Revenue|null = null

  private isModalOpen: boolean = false

  private title: string = ''

  private localCopy: Invoice = new Invoice()

  private get selectedRevenueFields(): Array<string|{}> {
    return ['name',
      {
        key: 'total',
        formatter: formatters.decimal,
        class: 'text-right',
      },
      {
        key: 'actions',
        label: '',
        class: 'text-center',
      },
    ]
  }

  private get filteredRevenueOptions(): Array<{ value: Revenue, text: string }> {
    return this.revenues
      .filter((r) => r.customerId === this.localCopy.customer.code && r.status === 'created')
      .filter((r) => this.localCopy.items.findIndex((rev) => rev.id === r.id) === -1)
      .map((value) => ({ value, text: value.name }))
  }

  public mounted() {
    this.fetchRevenues()
  }

  public async _commit(value: Invoice, buttonEvent: any) {
    // Validate

    // Write to User
    await this.writeInvoice(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Invoice) {
    // emit!
  }

  // PUBLIC Interface

  public edit(invoice: Invoice) {
    this.show()
    this.title = `Edit Invoice: ${invoice.id}`
    this.localCopy = new Invoice(invoice)      // Copy invoice!
  }

  public create() {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Invoice'
    this.localCopy = new Invoice()
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
